import styled from 'styled-components';

export default styled.div`
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(43, 48, 58, 0.1);
  background-color: #424a5a;
  padding: 10px;
  margin-bottom: 10px;
`;
